// extracted by mini-css-extract-plugin
export default {"title":"Hq-cO","subtitle":"wkH-D","form":"_5Klt1","submit":"c2zhz","skeleton-progress":"CzPUB"};